<template>
  <div class="profile-container">
    <!-- 个人中心 (step=5) -->
    <div v-show="activeTab === 'profile'">
      <!-- 头部背景与用户信息 -->
      <div class="header-section">
        <!-- 顶部操作栏 -->
        <div class="top-bar">
          <van-icon name="setting-o" class="action-icon" @click="$toast('点击了设置')" />
          <van-icon name="chat-o" badge="9" class="action-icon" @click="$toast('点击了消息')" />
        </div>

        <!-- 用户信息 -->
        <div class="user-info">
          <div class="avatar-wrapper">
            <van-image 
              round 
              width="68px" 
              height="68px" 
              src="https://picsum.photos/200/200?random=avatar" 
              class="avatar" 
            />
            <div class="vip-badge" v-if="userInfo.is_vip">VIP</div>
          </div>
          
          <div class="info-text">
            <div class="username">
              {{ userInfo.username || '非会员' }}
              <van-tag color="linear-gradient(to right, #ff6034, #ee0a24)" text-color="#fff" round size="small" class="level-tag" v-if="userInfo.is_vip">尊享会员</van-tag>
            </div>
            <div class="user-id" v-if="shareAgentCode">
              播放口令: {{ shareAgentCode }} 
              <van-icon name="description" class="copy-icon" @click="handleCopy(shareAgentCode)" />
            </div>
          </div>
        </div>

        <!-- 数据面板 -->
        <div class="data-panel">
          <div class="data-item">
            <div class="num">{{ userInfo.integral || 0 }}</div>
            <div class="label">我的积分</div>
          </div>
          <div class="data-item">
            <div class="num">{{ userInfo.tickets || 0 }}</div>
            <div class="label">观影券</div>
          </div>
          <div class="data-item" @click="onTabClick('favorite')">
            <div class="num">{{ userInfo.collect_count || 0 }}</div>
            <div class="label">已收藏</div>
          </div>
          <div class="data-item" @click="onTabClick('purchased')">
            <div class="num">{{ userInfo.pay_count || 0 }}</div>
            <div class="label">已购买</div>
          </div>
        </div>
      </div>

      <!-- 核心栏目列表区 -->
      <div class="menu-list">
        <van-cell-group :border="false" class="light-cell-group">
          <van-cell title="我的收藏" icon="like-o" is-link @click="onTabClick('favorite')" />
          <van-cell title="我的购买" icon="bag-o" is-link @click="onTabClick('purchased')" />
          <van-cell title="开通会员" icon="gem-o" is-link value="享尊贵特权" @click="$router.push('/pay')" />
        </van-cell-group>
      </div>

      <!-- 补充功能列表区 -->
      <div class="menu-list">
        <van-cell-group :border="false" class="light-cell-group">
          <van-cell title="退出登录" icon="close" is-link @click="handleLogout" v-if="isLogin" />
          <van-cell title="联系客服" icon="service-o" is-link @click="$toast('联系客服')" />
          <van-cell title="帮助与反馈" icon="question-o" is-link @click="$toast('帮助与反馈')" />
        </van-cell-group>
      </div>
    </div>

    <!-- 底部炫酷导航栏 (浅色版) -->
    <div class="light-tabbar">
      <div class="tab-item" :class="{ active: activeTab === 'home' }" @click="onTabClick('home')">
        <van-icon name="wap-home-o" class="tab-icon" />
        <span class="tab-text">首页</span>
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'purchased' }" @click="onTabClick('purchased')">
        <van-icon name="bag-o" class="tab-icon" />
        <span class="tab-text">已购买</span>
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'favorite' }" @click="onTabClick('favorite')">
        <van-icon name="like-o" class="tab-icon" />
        <span class="tab-text">已收藏</span>
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'profile' }" @click="onTabClick('profile')">
        <van-icon name="user-o" class="tab-icon" />
        <span class="tab-text">我的</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserProfile',
  data() {
    return {
      activeTab: 'profile', // 底部导航激活状态为个人中心
    };
  },
  methods: {
    // 底部导航点击
    onTabClick(tab) {
      this.activeTab = tab;
      if (tab === 'home') {
        this.$router.push('/book');
      } else if (tab === 'purchased') {
        this.$toast('跳转到: 已购买(已付费小说)');
      } else if (tab === 'favorite') {
        this.$toast('跳转到: 已收藏');
      } else {
        // 当前已经在个人中心
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/* 页面浅色背景 */
.profile-container {
  min-height: 100vh;
  background-color: #f7f8fa; /* 统一浅色灰底 */
  color: #323233;
  padding-bottom: 90px; /* 为底部导航留出空间 */
}

/* ================= 头部区域 ================= */
.header-section {
  background: #ffffff;
  padding: 20px 20px 30px;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  position: relative;
  margin-bottom: 20px;
  
  .top-bar {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    margin-bottom: 20px;
    
    .action-icon {
      font-size: 22px;
      color: #323233;
      
      &:active {
        opacity: 0.7;
      }
    }
  }
}

.user-info {
  display: flex;
  align-items: center;
  margin-bottom: 30px;

  .avatar-wrapper {
    position: relative;
    
    .avatar {
      border: 2px solid #ffffff; 
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }
    
    .vip-badge {
      position: absolute;
      bottom: -2px;
      left: 50%;
      transform: translateX(-50%);
      background: linear-gradient(to right, #ff6034, #ee0a24);
      color: #ffffff;
      font-size: 10px;
      font-weight: bold;
      padding: 2px 8px;
      border-radius: 10px;
      border: 1px solid #ffffff;
    }
  }

  .info-text {
    flex: 1;
    margin-left: 16px;

    .username {
      font-size: 18px;
      font-weight: bold;
      color: #323233;
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 6px;
      
      .level-tag {
        font-weight: bold;
      }
    }

    .user-id {
      font-size: 12px;
      color: #969799;
      display: flex;
      align-items: center;
      
      .copy-icon {
        margin-left: 6px;
        font-size: 14px;
        cursor: pointer;
        
        &:active {
          color: #ee0a24;
        }
      }
    }
  }
}

.data-panel {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  
  .data-item {
    text-align: center;
    
    .num {
      font-size: 18px;
      font-weight: bold;
      color: #323233;
      margin-bottom: 6px;
      font-family: Arial, Helvetica, sans-serif;
    }
    
    .label {
      font-size: 12px;
      color: #969799;
    }
  }
}

/* ================= 菜单列表区 ================= */
.menu-list {
  margin: 0 16px 16px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  background: #ffffff;
}

::v-deep .light-cell-group {
  .van-cell {
    padding: 16px;
    color: #323233;
    
    .van-cell__left-icon {
      font-size: 20px;
      margin-right: 12px;
      color: #ee0a24; /* 图标使用主题红 */
    }
    
    .van-cell__right-icon {
      color: #c8c9cc;
    }
    
    .van-cell__value {
      color: #969799;
      font-size: 12px;
    }
    
    &:active {
      background-color: #f2f3f5;
    }
  }
}

/* ================= 炫酷底部导航 (浅色版) ================= */
.light-tabbar {
  position: fixed;
  bottom: 16px;
  left: 16px;
  right: 16px;
  height: 64px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 32px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  z-index: 100;
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #969799; /* 默认灰色 */
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 60px;
  position: relative;
  
  .tab-icon {
    font-size: 22px;
    margin-bottom: 4px;
    transition: transform 0.3s;
  }
  
  .tab-text {
    font-size: 10px;
    font-weight: 500;
    transition: all 0.3s;
  }
  
  &.active {
    color: #ee0a24; /* 选中状态为红色 */
    
    .tab-icon {
      transform: translateY(-4px) scale(1.1);
      color: #ee0a24;
    }
    
    .tab-text {
      transform: translateY(-2px);
      font-weight: bold;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: -4px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #ee0a24;
    }
  }
  
  &:active {
    transform: scale(0.9);
  }
}
</style>
